import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarService } from '../../../services/sidebar/sidebar.service';


declare let $: any;
@Component({
  selector: 'app-full',
  templateUrl: './full.component.html'
})
export class FullComponent implements OnInit {

  isSidebarOpen: boolean;
  
  constructor(
    private sidebarService: SidebarService,
    private router: Router
  ) { 
    this.sidebarService.openSidebar.subscribe(open => {
      this.isSidebarOpen = open;
    });
  }

  ngOnInit(): void { 
    if (this.router.url === '/') {
      this.router.navigate(['/home']);
    }
  }
}
